import module from "./MonthReport.module.css";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button, Card, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import fetchRewards from "../../util/fetchRewards";
import AnnounceChangeMonth from "./AnnounceChangeMonth";
import AnnounceAgeLimit from "./AnnounceAgeLimit";
import ApologyForMonthError from "./ApologyForMonthError";
import { isTargetForApologyForMonthError } from "../../util/apologyForMonthError";

function MonthReport(props) {
  const [inviteNum, setInviteNum] = useState(0);
  const [amount, setAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [sub, setSub] = useState("");

  const isDuplicated = (result) => {
    let isDuplicated = false;
    const ids = new Set();
    result.forEach((item) => {
      if (ids.has(item.id)) {
        isDuplicated = true;
      }
      ids.add(item.id);
    });
    return isDuplicated;
  };

  const getInviteeData = async () => {
    try {
      setIsLoading(true);
      const user = await Auth.currentAuthenticatedUser();
      const result = await fetchRewards(user.attributes.sub, null, []);
      const now = new Date();
      const currentMonthRecords = result.filter((item) => {
        const createdAt = new Date(item.createdAt);
        return (
          createdAt.getMonth() === now.getMonth() &&
          createdAt.getFullYear() === now.getFullYear()
        );
      });
      isDuplicated(currentMonthRecords);
      if (isDuplicated(currentMonthRecords)) {
        setIsLoading(false);
        alert("集計時にエラーが発生しました。問い合わせよりご連絡ください。");
        return null;
      }
      setSub(user.attributes.sub);
      setInviteNum(currentMonthRecords.length);
      setAmount(
        currentMonthRecords.reduce((acc, cur) => acc + Number(cur.amount), 0)
      );
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInviteeData();
  }, []);

  const remainingPeriod = () => {
    const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const remaining = lastDay.getDate() - today.getDate();
    return remaining;
  };

  const AnnounceController = () => {
    const DISPLAY_NEW_MONTH_INFO_PERIOD = 3;
    const AGE_LIMIT = 18;
    const currentDate = new Date();

    const currentDay = currentDate.getDate();
    const isNewMonth = currentDay < DISPLAY_NEW_MONTH_INFO_PERIOD;

    function AgeLimit() {
      try {
        const userAge = props.userAge;
        if (!userAge) return false;
        const userBirthdate = userAge.split("-");
        const userBirthdateYear = userBirthdate[0];
        const userBirthdateMonth = userBirthdate[1];
        const userBirthdateDay = userBirthdate[2];

        const birthdate = new Date(userBirthdateYear, userBirthdateMonth - 1, userBirthdateDay);

        const currentYearBirthday = new Date(currentDate.getFullYear(), birthdate.getMonth(), birthdate.getDate());
        let age = currentDate.getFullYear() - birthdate.getFullYear();

        if (currentDate < currentYearBirthday) {
          age--;
        }

        return age < AGE_LIMIT;
      } catch (e) {
        return false;
      }
    }

    if (AgeLimit()) return <AnnounceAgeLimit />;
    if (isNewMonth) return <AnnounceChangeMonth />;
    if (sub && isTargetForApologyForMonthError(sub)) return <ApologyForMonthError />;
    return null;
  }

  return (
    <Card
      sx={{
        margin: "32px 0px 16px",
        position: "relative",
        zIndex: 1,
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // width is lower than 640px, then the margin will be 16px
        "@media (max-width: 640px)": {
          margin: "32px 16px 16px",
        },
      }}
    >
      <div className={module.warpCardTitle}>
        <span className={module.cardTitle} sx={{ fontWeight: "bold" }}>
          今月のレポート
        </span>
        <div className={module.triangle} />
      </div>
      <AnnounceController />
      <div className={module.cardContent}>
        <div className={module.imgTree}>
          <img src={process.env.PUBLIC_URL + "/svg/tree.svg"} alt="tree" />
        </div>
        <div className={module.wrapRemind}>
          <span className={module.remind}>
            今月の締め日まであと{remainingPeriod()}日です
          </span>
        </div>
        <div className={module.monthlyInfo}>
          <div>
            <div>
              <span className={module.contentSub}>今月の紹介者数</span>
            </div>
            <div>
              <span className={module.contentMain}>
                {isLoading ? <CircularProgress color="success" /> : inviteNum}
              </span>
              <span className={module.contentSub}>人</span>
            </div>
          </div>
          <div>
            <div>
              <span className={module.contentSub}>今月の報酬予定金額</span>
            </div>
            <div>
              <span className={module.contentMain}>
                {isLoading ? <CircularProgress color="success" /> : amount}
              </span>
              <span className={module.contentSub}>円</span>
            </div>
          </div>
        </div>
        <div className={module.verticalDivider} />
      </div>
      <div>
        <div className={module.reportDetail}>
          <Button
            color="secondary"
            LinkComponent={Link}
            to="/mypage/history"
            endIcon={<ChevronRightIcon />}
            sx={{ fontSize: "0.8rem" }}
          >
            レポート詳細
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default MonthReport;
